import { Combobox } from '@/components/common/Combobox'
import { useTaskActionTypes } from '../hooks'
import { iconForActionType } from './actionTypeIcons'

interface Props {
  value: string | null // null = "Wszystkie"
  onChange: (code: string | null) => void
}

/** Combobox filter nad kanbanem - wybierz typ akcji, kanban pokazuje tylko pasujące karty.
 *  null = "Wszystkie akcje" (brak filtra). Pełne listy są krótkie, search ukryty. */
export function ActionTypeFilter({ value, onChange }: Props) {
  const { data: types = [], isLoading } = useTaskActionTypes()

  const options = types.map((t) => {
    const Icon = iconForActionType(t.code)
    return {
      value: t.code,
      label: t.label,
      prefix: <Icon className="size-3.5 shrink-0 text-slate-500" />,
    }
  })

  return (
    <div className="flex items-center gap-2">
      <label className="text-xs font-medium text-slate-600">Akcja:</label>
      <Combobox<string>
        value={value}
        onChange={onChange}
        options={options}
        placeholder="Wszystkie"
        emptyOptionLabel="Wszystkie"
        disabled={isLoading}
        className="min-w-44"
      />
    </div>
  )
}
